import React from 'react';
import { Link } from 'react-router-dom';
import { products_content } from '../../content/products/productsContent';

// slug helper (KEEP HERE - logic, not content)
const createSlug = (name: string) =>
  name.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');

const Products: React.FC = () => {
  return (
    <div className="min-h-screen bg-[#FFFDF8] px-4 sm:px-6 lg:px-8 py-16">
      <div className="max-w-7xl mx-auto pt-20">

        <h1
          className="text-[48px] text-[#021847] mb-7"
          style={{ fontFamily: 'Roboto Serif' }}
        >
          {products_content.header.title}
        </h1>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-10 gap-y-14">
          {products_content.products.map((product) => {
            const slug = createSlug(product.name);

            return (
              <div key={product.id} className="flex flex-col">

                <Link
                  to={`/products/${slug}`}
                  state={{ product }}
                  className="group relative block"
                >
                  <div className="h-[270px] rounded-[18px] overflow-hidden bg-[#EEEBE4]">
                    <img
                      src={product.image}
                      alt={product.name}
                      loading="lazy"
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>

                  <div className="absolute inset-0 rounded-[18px] bg-black/20 opacity-0 group-hover:opacity-100 transition duration-300 flex items-center justify-center">
                    <span className="bg-[#021847] text-white text-xs px-4 py-2 rounded-md">
                      View Details
                    </span>
                  </div>
                </Link>

                <div className="pt-5">
                  <h3 className="text-[18px] font-semibold text-[#2B2B2B] uppercase leading-tight mb-3">
                    {product.name}
                  </h3>

                  <p
                    className="text-[15px] text-[#666666] leading-7 overflow-hidden"
                    style={{
                      display: '-webkit-box',
                      WebkitLineClamp: 4,
                      WebkitBoxOrient: 'vertical',
                    }}
                  >
                    {product.description}
                  </p>
                </div>

              </div>
            );
          })}
        </div>

      </div>
    </div>
  );
};

export default Products;